<template>
  <ViewerLayoutRoot class="content-guest-layout" data-testid="content-guest-layout">
    <GuestTopBar />

    <div class="content-guest-layout__content">
      <ViewerContent />
      <MetadataSection :show-toolbar="false" />
    </div>

    <!-- Engagement Bar -->
    <EngagementBar />

    <!-- Tabs -->
    <div class="content-guest-layout__tabs">
      <ContentGuestTabs @addedComment="emit('addedComment')" />
    </div>
  </ViewerLayoutRoot>
</template>

<script setup lang="ts">
import ViewerContent from '@/modules/viewer/components/Content.vue';
import GuestTopBar from '../../shared/GuestTopBar.vue';
import EngagementBar from '../../shared/EngagementBar.vue';
import MetadataSection from '../../shared/MetadataSection.vue';
import ContentGuestTabs from './ContentGuestTabs.vue';

import ViewerLayoutRoot from '../../shared/ViewerLayoutRoot.vue';
const emit = defineEmits<{
  addedComment: [];
}>();
</script>

<style scoped>
.content-guest-layout__content {
  @apply flex flex-col min-w-0;
}

.content-guest-layout__tabs {
  @apply mt-2;
}
</style>
